import axios from 'axios'
import store from '@/uteis/store'
import axiosRetry from 'axios-retry'
import { refreshToken } from '@/uteis/effects/token'
import { updateExpires } from '@/uteis/localStorage'

const http = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_URL || '',
  headers: {
    Accept: 'application/json',
    Content: 'application/json',
    'Access-Control-Allow-Origin': '*'
  }
})

http.interceptors.request.use(async function (res) {
  updateExpires('client_id', 1000 * 60 * 18)
  if (!res.url.includes('/controles/sessao')) {
    res.headers = {
      ...res.headers,
      id_client: store.getters.getDadosSessao.id
    }
  }

  return res
}, function (erro) {
  return Promise.reject(erro)
})

http.interceptors.response.use(function (res) {
  updateExpires('client_id', 1000 * 60 * 18)
  return res
}, function (erro) {
  if (erro.response.status !== 401 || erro.response.data.status === 'Perfil com acesso negado!') {
    return Promise.reject(erro)
  }

  return refreshToken().then(res => {
    return Promise.reject(erro)
  }).catch(refreshError => {
    return Promise.reject(refreshError)
  })
})

axiosRetry(http, { retries: 3 })
export default http
